export default __webpack_public_path__ + "static/media/search.8bd0f91f.svg";